import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'RequestChangeEmail',
  components: {
    EmailComp: require('@/components/email.vue').default,
  },
  data: function () {
    return {
      password: '',
      currentEmail: { email: '', valid: false, descr: this.$t('Current Email') },
      email: { email: '', valid: false, descr: this.$t('changePassword.NewEmail') },
      message: '',
      isError: false,
      isChangeEmailDisabled: false,

      bOTPSent: false,
      otpCode: '',
      completed: false,
      showMsg: false,
      isInComm: false,
    }
  },
  computed: {
    changeEmailButtDisabled: function () {
      if (this.isChangeEmailDisabled)
        return true;

      return this.email.email == null || !this.email.valid || this.password == null || this.password.length == 0;
    },
    messageClass: function () {
      return this.isError ? 'error-class' : '';
    }
  },
  created() {
    let sett = this.$store.getters.getProfileDetails;

    if (sett && sett.registrationType != 1)
      this.$router.push('/login');

  },
  methods: {
    redirectBack() {
      this.$router.go(-1);
    },
    changeEmail() {
      if (this.email.email == this.currentEmail.email) {
        this.$notify({ duration: 10000, group: 'app', text: this.$t('login.SameEmailProvided'), type: 'warn' });
        return;
      }

      if (this.changeEmailButtDisabled && !this.bOTPSent)
        return;

      let temp = this.$store.getters.getProfileDetails;
      if (!this.currentEmail.valid || !temp || this.currentEmail.email != temp.email) {
        this.$notify({ duration: 10000, group: 'app', text: this.$t('login.WrongEmail'), type: 'warn' });
        return;
      }

      this.setMessage();
      
      this.$root.$emit('enable_disable_loader', true);
      axios.post('/account/ChangeEmail', { Password: this.password, NewEmail: this.email.email, SendOtpCode: true })
        .then(response => {
          if (response.status == 200 && (!response.data || response.data.data.status == 0)) {
            this.isChangeEmailDisabled = true;
            this.bOTPSent = true;
          }
          else {
            this.setMessage(response.data.data.text, true);
            this.bOTPSent = false;
          }
           this.$root.$emit('enable_disable_loader', false);
        })
        .catch(e => {
          this.setMessage(`Error: ${e}`, true);
          this.bOTPSent = false;
          this.$root.$emit('enable_disable_loader', false);
        });
    },
    setMessage(msg, isError = false) {
      if (msg == null || msg == '') {
        this.message = msg;
        this.isError = false;
        return;
      }

      this.message = msg;
      this.isError = isError;
    },

    changeEmailComplete() {
      this.isInComm = true;
      this.$root.$emit('enable_disable_loader', true);
      axios.post('/account/ChangeEmailComplete', { Password: this.password, Email: this.email.email, OtpCode: this.otpCode })
        .then(response => {
          this.isInComm = false;
          if (response.status == 200) {

            this.$root.$emit('get_profile_details');
            this.redirectBack();
            this.showMessage(this.$t('EmailSuccess'), 3);
          }
          else {
            this.message = response.data.data.text;
            this.showMessage(this.message, 2)
            setTimeout(() => { this.showMsg = false; }, 5000);
          }
          this.$root.$emit('enable_disable_loader', false);
          this.showMsg = true;
        })
        .catch(e => { this.message = e.message; this.completed = true; this.showMsg = true; this.$root.$emit('enable_disable_loader', false); })
    },
    showMessage(msg, type) {
      this.message = msg;
      if (type === 1)
        this.message += ' ' + this.$t('messages.ProblemPersistsContactSupport');
      this.$notify({ duration: 10000, group: 'app', text: msg, type: type == 1 ? 'warn' : type == 2 ? 'error' : type == 3 ? 'success' : '' }); // title: '',
    },
  },
}
